// extracted by mini-css-extract-plugin
export default {"quota-group-dropdown":"QuotaGroupDropdown_quota-group-dropdown__3429T"};